
export default function Logout() {
  sessionStorage.clear();
  window.location.replace(window.location.origin);

  return(<p></p>);
}
